import { Type } from 'class-transformer';
import { IsIn, IsInt, IsOptional, IsString, Max, MaxLength, Min } from 'class-validator';
import {
  SURVEY_INVITE_ID_MAX_LENGTH,
  SURVEY_INVITE_LIST_DEFAULT_PAGE_SIZE,
  SURVEY_INVITE_LIST_MAX_PAGE_SIZE,
  SURVEY_INVITE_SEARCH_MAX_LENGTH,
  SURVEY_INVITE_STATUSES,
  type SurveyInviteStatus,
} from '../../types/survey-invite';

export class SurveyInviteQueryDto {
  /** Stato derivato (spec §4.6): il backend lo calcola in SQL con la stessa regola di `deriveSurveyInviteStatus`. */
  @IsOptional()
  @IsIn(SURVEY_INVITE_STATUSES)
  status?: SurveyInviteStatus;

  @IsOptional()
  @IsString()
  @MaxLength(SURVEY_INVITE_ID_MAX_LENGTH)
  tenantId?: string;

  /** Nome cliente, destinatario o prefisso token. */
  @IsOptional()
  @IsString()
  @MaxLength(SURVEY_INVITE_SEARCH_MAX_LENGTH)
  q?: string;

  @Type(() => Number)
  @IsInt()
  @Min(1)
  page: number = 1;

  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(SURVEY_INVITE_LIST_MAX_PAGE_SIZE)
  pageSize: number = SURVEY_INVITE_LIST_DEFAULT_PAGE_SIZE;
}
